import styled from '@emotion/styled';

const StyledForm = styled('form')({
  display: 'flex',
  alignItems: 'center',
});

export default StyledForm;
